import Chart from "chart.js/dist/chart.js";

export function setupEmailChartHook() {
  return {
    labels() {
      return JSON.parse(this.el.dataset.labels);
    },
    delivered() {
      return JSON.parse(this.el.dataset.delivered);
    },
    opens() {
      return JSON.parse(this.el.dataset.opens);
    },
    clicks() {
      return JSON.parse(this.el.dataset.clicks);
    },
    bounces() {
      return JSON.parse(this.el.dataset.bounces);
    },
    unsubscribes() {
      return JSON.parse(this.el.dataset.unsubscribes);
    },
    currentChart: null,
    mounted() {
      Chart.register();
      this.renderChart();
    },
    updated() {
      if (this.currentChart) {
        this.currentChart.destroy();
      }
      this.renderChart();
    },
    renderChart() {
      const ctx = this.el.getContext("2d");

      this.currentChart = new Chart(ctx, {
        type: "line",
        data: {
          labels: this.labels(),
          datasets: [
            {
              label: "Delivered",
              data: this.delivered(),
              borderColor: "rgb(6, 182, 212)",
              backgroundColor: "rgba(6, 182, 212, 0.08)",
              borderWidth: 2,
              fill: false,
              tension: 0.3,
              pointRadius: 2,
              pointHoverRadius: 5,
            },
            {
              label: "Opens",
              data: this.opens(),
              borderColor: "rgb(16, 185, 129)",
              backgroundColor: "rgba(16, 185, 129, 0.08)",
              borderWidth: 2,
              fill: false,
              tension: 0.3,
              pointRadius: 2,
              pointHoverRadius: 5,
            },
            {
              label: "Clicks",
              data: this.clicks(),
              borderColor: "rgb(59, 130, 246)",
              backgroundColor: "rgba(59, 130, 246, 0.08)",
              borderWidth: 2,
              fill: false,
              tension: 0.3,
              pointRadius: 2,
              pointHoverRadius: 5,
            },
            {
              label: "Bounces",
              data: this.bounces(),
              borderColor: "rgb(244, 63, 94)",
              backgroundColor: "rgba(244, 63, 94, 0.08)",
              borderWidth: 2,
              fill: false,
              tension: 0.3,
              pointRadius: 2,
              pointHoverRadius: 5,
            },
            {
              label: "Unsubscribes",
              data: this.unsubscribes(),
              borderColor: "rgb(245, 158, 11)",
              backgroundColor: "rgba(245, 158, 11, 0.08)",
              borderWidth: 2,
              fill: false,
              tension: 0.3,
              pointRadius: 2,
              pointHoverRadius: 5,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          interaction: {
            mode: "index",
            intersect: false,
          },
          plugins: {
            legend: {
              display: true,
              position: "top",
              align: "end",
              labels: {
                usePointStyle: true,
                pointStyle: "circle",
                padding: 16,
                font: { size: 11 },
              },
            },
            datalabels: {
              display: false,
            },
            tooltip: {
              backgroundColor: "rgba(0, 0, 0, 0.8)",
              padding: 12,
              cornerRadius: 8,
              titleFont: { size: 13 },
              bodyFont: { size: 12 },
            },
          },
          scales: {
            x: {
              grid: { display: false },
              ticks: {
                font: { size: 11 },
                color: "#9ca3af",
                maxTicksLimit: 12,
              },
            },
            y: {
              beginAtZero: true,
              grid: {
                color: "rgba(0, 0, 0, 0.04)",
              },
              ticks: {
                font: { size: 11 },
                color: "#9ca3af",
                precision: 0,
                padding: 8,
              },
            },
          },
        },
      });
    },
  };
}
